
import { AppMenuMixin } from '../../apps/app-menu/mixin'
import { Component, Mixins } from '~/utility/pu-class-decorator'

@Component
export default class AppHeader extends Mixins(AppMenuMixin) {}
